import { PlusIcon } from 'lucide-react'
import React from 'react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from 'src/components/ui/dropdown-menu'
import folder from 'src/assets/icons/document_types/folder.svg'
import file_upload from 'src/assets/icons/document_types/file_upload.svg'
import docx from 'src/assets/icons/document_types/docx.svg'
import xlsx from 'src/assets/icons/document_types/xlsx.svg'
import clipchamp from 'src/assets/icons/document_types/clipchamp.svg'
import onetoc from 'src/assets/icons/document_types/onetoc.svg'
import pptx from 'src/assets/icons/document_types/pptx.svg'
import vsdx from 'src/assets/icons/document_types/vsdx.svg'
import toast from 'react-hot-toast'
import { createEmptyFile, uploadFileToOneDrive } from 'src/graph'
import { useMS } from 'src/components/files/onedrive/context/MSContext'

type P = {
    onSuccess?: () => void;
    folderId: string
}

const AddToDrive = ({onSuccess, folderId}:P) => {
    const { accessToken } = useMS()

    const handleAddDocument = async (event:any) => {
        const file = event.target.files[0]

        if(!file) { console.log('Select a file'); return; }

        try {
            toast.loading('Document toevoegen...', {id:'add-document'})
            const res = await uploadFileToOneDrive(accessToken, file, folderId)
            console.log(res)
            toast.success('Document toegevoegd', {id:'add-document'})
            onSuccess && onSuccess()
        } catch (error) {
            toast.error('Document toevoegen mislukt', {id:'add-document'})
            console.log(error);
        }
    };

    const handleCreateDocument = async (doctype:string) => {
        const createdFile = await createEmptyFile(accessToken, doctype, folderId)
        window.open(createdFile.webUrl)
        toast.success('Document toegevoegd', {id:'add-document'})
        onSuccess && onSuccess()
    }

  return (
    <DropdownMenu>
        <DropdownMenuTrigger asChild>
            <button className='w-8 h-8 rounded-sm flex items-center justify-center border border-solid border-transparent hover:border-neutral-200 hover:bg-neutral-100 disabled:opacity-30'><PlusIcon className='w-4 h-4 text-green-600'/></button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
            <DropdownMenuGroup>
                <DropdownMenuItem className='py-0' onSelect={(e)=>{e.preventDefault()}}>
                    <label htmlFor='file-upload' className='w-full h-full flex items-center gap-2 py-3 cursor-pointer'>
                        <img className='w-4 h-4' src={file_upload} alt="file_upload" />
                        Bestanden uploaden
                    </label>
                    <input onChange={handleAddDocument} className='hidden' type="file" id='file-upload'/>
                </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
                <DropdownMenuItem className='py-0'>
                    <button onClick={()=>{handleCreateDocument('docx')}} className='w-full h-full flex items-center gap-2 py-3'>
                        <img className='w-4 h-4' src={docx} alt="docx" />
                        Word-document
                    </button> 
                </DropdownMenuItem>
                <DropdownMenuItem className='py-0'>
                    <button className='w-full h-full flex items-center gap-2 py-3'>
                        <img className='w-4 h-4' src={xlsx} alt="xlsx" />
                        Excel-werkmap
                    </button>
                </DropdownMenuItem>
                <DropdownMenuItem className='py-0'>
                    <button className='w-full h-full flex items-center gap-2 py-3'>
                        <img className='w-4 h-4' src={pptx} alt="pptx" />
                        PowerPoint-presentatie
                    </button>
                </DropdownMenuItem>
                <DropdownMenuItem className='py-0'>
                    <button className='w-full h-full flex items-center gap-2 py-3'>
                        <img className='w-4 h-4' src={onetoc} alt="onetoc" />
                        OneNote-notitieblok
                    </button>
                </DropdownMenuItem>
                <DropdownMenuItem className='py-0'>
                    <button className='w-full h-full flex items-center gap-2 py-3'>
                        <img className='w-4 h-4' src={vsdx} alt="vsdx" />
                        Visio-tekening
                    </button>
                </DropdownMenuItem>
                <DropdownMenuItem className='py-0'>
                    <button className='w-full h-full flex items-center gap-2 py-3'>
                        <img className='w-4 h-4' src={clipchamp} alt="clipchamp" />
                        Clipchamp-video
                    </button>
                </DropdownMenuItem>
            </DropdownMenuGroup>
        </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default AddToDrive